// ============================================================================
// WELCOME PAGE COMPONENT
// Created by Salvador Janeiro
// ============================================================================

import React from 'react';
import { Leaf, Users, Building2, ArrowRight } from 'lucide-react';

const WelcomePage = ({ onSelectType }) => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-green-50 via-blue-50 to-teal-50 flex items-center justify-center p-4">
      <div className="max-w-4xl w-full">
        {/* Header */}
        <div className="text-center mb-12">
          <div className="flex justify-center mb-6">
            <Leaf className="text-green-600" size={64} />
          </div>
          <h1 className="text-5xl font-bold text-gray-800 mb-4">
            How Sustainable Are You?
          </h1>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Discover your environmental impact with our comprehensive sustainability assessment. 
            Get personalized insights on your carbon footprint, water usage, and waste generation.
          </p>
        </div>

        {/* Selection Cards */}
        <div className="grid md:grid-cols-2 gap-6 mb-8">
          {/* Individual Card */}
          <button
            onClick={() => onSelectType('individual')}
            className="bg-white rounded-2xl shadow-xl p-8 hover:shadow-2xl transition-all hover:scale-105 group"
          >
            <div className="flex flex-col items-center text-center">
              <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mb-4 group-hover:bg-green-200 transition-colors">
                <Users size={40} className="text-green-600" />
              </div>
              <h2 className="text-2xl font-bold text-gray-800 mb-2">Individual</h2>
              <p className="text-gray-600 mb-4">
                Assess your personal lifestyle and environmental impact. Get tailored recommendations 
                for sustainable living.
              </p>
              <div className="mt-6 flex items-center text-green-600 font-semibold">
                Start Assessment <ArrowRight size={20} className="ml-2" />
              </div>
            </div>
          </button>

          {/* Company Card */}
          <button
            onClick={() => onSelectType('company')}
            className="bg-white rounded-2xl shadow-xl p-8 hover:shadow-2xl transition-all hover:scale-105 group"
          >
            <div className="flex flex-col items-center text-center">
              <div className="w-20 h-20 bg-blue-100 rounded-full flex items-center justify-center mb-4 group-hover:bg-blue-200 transition-colors">
                <Building2 size={40} className="text-blue-600" />
              </div>
              <h2 className="text-2xl font-bold text-gray-800 mb-2">Company</h2>
              <p className="text-gray-600 mb-4">
                Evaluate your organization's ESG performance and SDG alignment. Benchmark against 
                industry standards.
              </p>
              <div className="mt-6 flex items-center text-blue-600 font-semibold">
                Start Assessment <ArrowRight size={20} className="ml-2" />
              </div>
            </div>
          </button>
        </div>

        {/* Contact Section - ADD THIS */}
        <div className="mt-8 bg-white rounded-xl shadow-lg p-6">
          <div className="text-center">
            <h3 className="text-xl font-bold text-gray-800 mb-2">
              Need Sustainability Consulting?
            </h3>
            <p className="text-gray-600 mb-4">
              Get expert guidance on reducing your environmental impact
            </p>
            <div className="flex flex-col sm:flex-row justify-center gap-3">
              <a
                href="mailto:salvadorjaneiro02@gmail.com"
                className="inline-flex items-center justify-center px-4 py-2 bg-green-600 text-white rounded-lg text-sm font-semibold hover:bg-green-700 transition-all"
              >
               📧 Email Me
              </a>
              <a
                href="https://www.linkedin.com/in/salvador-janeiro-419010296"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center px-4 py-2 bg-blue-600 text-white rounded-lg text-sm font-semibold hover:bg-blue-700 transition-all"
              >
                💼 Connect on LinkedIn
              </a>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="text-center text-gray-500 text-sm">
          <p>Created by Salvador Janeiro</p>
        </div>
      </div>
    </div>
  );
};

export default WelcomePage;
